<mat-toolbar color="primary">
  <span class="app-title">Initiative Hub</span>
  <span class="toolbar-spacer"></span>
  @if (loggedIn) {
    <span class="toolbar-user">{{ userName }}</span>
    <button mat-icon-button (click)="switchAccount()" matTooltip="Switch account">
      <mat-icon>manage_accounts</mat-icon>
    </button>
    <button mat-icon-button (click)="logout()" matTooltip="Sign out">
      <mat-icon>logout</mat-icon>
    </button>
  }
</mat-toolbar>

<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  <a mat-tab-link routerLink="/initiatives" routerLinkActive #rla1="routerLinkActive" [active]="rla1.isActive">
    Business Initiatives
  </a>
  <a mat-tab-link routerLink="/dev-requests" routerLinkActive #rla2="routerLinkActive" [active]="rla2.isActive">
    Development Requests
  </a>
  <a mat-tab-link routerLink="/resource-requests" routerLinkActive #rla3="routerLinkActive" [active]="rla3.isActive">
    Resource Requests
  </a>
</nav>

<mat-tab-nav-panel #tabPanel>
  <div class="content-container">
    <router-outlet />
  </div>
</mat-tab-nav-panel>
